import {
    deleteInformation,
    getInformation,
    getInformationList,
    registerInformation,
    RegisterInformationRequestType
} from "./api";
import { InformationId } from "../../../domain/information/InformationId";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../app/funcs/orderResultToast";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Information",
    getInformationList: "getInformationList",
    getInformation: "getInformation",
    register: "register",
    delete: "delete"
});

export const getInformationListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getInformationList}`,
    async (_, { rejectWithValue }) => {
        const response = await getInformationList();

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const getInformationAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getInformation}`,
    async (informationId: InformationId, { rejectWithValue }) => {
        const response = await getInformation(informationId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { information: response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const registerInformationAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.register}`,
    async (data: {
        requestData: RegisterInformationRequestType
    }, { rejectWithValue }) => {
        const response = await registerInformation(data.requestData);

        if (response.error === undefined) {
            orderSuccessToast("お知らせを登録しました");
            return { information: response };
        } else {
            // API処理結果異常の場合
            orderErrorToast("お知らせの登録に失敗しました");
            return rejectWithValue({});
        }
    }
);

export const deleteInformationAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.delete}`,
    async (data: {
        informationId: InformationId
    }, { rejectWithValue }) => {
        const response = await deleteInformation(data.informationId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            orderSuccessToast("お知らせを削除しました");
            return {};
        } else {
            // API処理結果異常の場合
            orderErrorToast("お知らせの削除に失敗しました");
            return rejectWithValue({});
        }
    }
);
